export default "__VITE_ASSET__LBgsDiAz__"